<script>

import Icon from "../Icon.vue";

export default {
  name: 'OrganizationCard',
  components: {Icon},
  props: {
    organization: {
      type: Object,
      required: true
    },
    labelColour: {
      type: String,
      default: "#3a4473" // Secondary color
    },
    selected: {
      type: Boolean,
      default: false
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {
  },

};
</script>


<template>
  <div class="p-4">
    <div class="flex items-center gap-4">
      <!-- Left: Rounded square with colored strip -->
      <div class="relative w-12 h-12 bg-gray-100 rounded-lg flex-shrink-0 flex items-center justify-center">
        <!-- Colored strip on the left -->
        <div
          class="absolute left-0 top-0 bottom-0 w-2 rounded-l-lg"
          :style="`background-color: ${labelColour};`"
        />
        <div class="text-2xl font-semibold text-gray-500">
          {{ organization.name.charAt(0) }}
        </div>
      </div>

      <!-- Main content: Organization name -->
      <div class="flex-1">
        <h3 class="text-sm sm:text-lg font-semibold flex items-center gap-2">
          {{ organization.name }}
          <span v-if="isDefault" class="text-xs font-medium bg-default_secondary_dark text-white px-2 py-0.5 rounded-full">Default</span>
        </h3>
      </div>

      <!-- Right: Icons placeholder -->
      <!--      <div class="border border-gray-300 border-dashed p-2 rounded flex-shrink-0">-->
      <!--        <span class="text-xs text-gray-500">Icons</span>-->
      <!--        <div> {{organization.member_count}}</div>-->
      <!--      </div>-->
      <div class="p-2 flex-shrink-0 flex flex-row">
        <div
          v-if="organization.descendant_count"
          class="inline-flex flex-row justify-items-end mr-6"
        >
          <icon
            icon="sitemap"
            size="24px"
            color="gray"
            class="mr-2"
          />
          <div>{{ organization.descendant_count || 0 }}</div>
        </div>
        <div class="inline-flex flex-row justify-items-end ">
          <icon
            icon="users"
            size="24px"
            color="gray"
            class="mr-2"
          />
          <div>{{ organization.member_count || 0 }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped lang="scss">

</style>
